import { GridColumnVisibilityModel } from "@mui/x-data-grid";
import { create } from "zustand";

export interface State {
  meeting: GridColumnVisibilityModel;
}

export interface Actions {
  updateColumnVisibility: (columnName: string, isVisible: boolean) => void;
  reset: () => void;
}

export type Store = State & Actions;

const initialState = {
  meeting: {
    meetingLink: true,
    entityName: true,
    entityType: true,
    universe: true,
    // Scheduled By
    authorName: true,
    // Meeting Type
    type: true,
    startDateTime: true,
    endDateTime: true,
    isAllDayEvent: true,
    annualMaterialsReceived: true,
    annualNotesReceived: true,
    inviteReceivedDate: true,
    commentRequired: true,
    attendeeTbd: true,
    caNotAttending: true,
    // Closed Private
    closed: true,
    topic: true,
    // Department
    attendeeGroup: true,
    caLeaders: true,
    caParticipants: true,
    managerParticipants: true,
    responsibleWriters: true,
    // Meeting Style
    style: true,
    meetingLocation: true,
    // Office Location
    caOffice: true,
    managerLocation: true,
    createdByPersonName: true,
    // Created Date
    creTimest: true,
    // Last modified By
    updatedByPersonName: true,
    // Last Modified Date
    modTimest: true,

    id: false,
    entityLegacyId: false,
    entityId: false,
    scheduledById: false,
    otherLocation: false,
    otherCountry: false,
    otherManagers: false,
    otherMeetingAttendees: false,
    createdById: false,
    updatedById: false,
  },
};

export const useMeetingColumnVisibilityStore = create<Store>((set) => ({
  ...initialState,
  updateColumnVisibility: (columnName: string, isVisible: boolean) => {
    set((state) => ({
      meeting: {
        ...state.meeting,
        [columnName]: isVisible,
      },
    }));
  },
  reset: () => set(initialState),
}));
